var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6822 6.80957C12.4152 6.80957 7.33301 11.8917 7.33301 18.1588V36.3175C7.33301 42.5845 12.4152 47.6667 18.6822 47.6667H36.8409C43.108 47.6667 48.1901 42.5845 48.1901 36.3175V18.1588C48.1901 11.8917 43.108 6.80957 36.8409 6.80957H18.6822ZM41.3806 11.3493C42.6336 11.3493 43.6505 12.3661 43.6505 13.6191C43.6505 14.872 42.6336 15.8889 41.3806 15.8889C40.1277 15.8889 39.1108 14.872 39.1108 13.6191C39.1108 12.3661 40.1277 11.3493 41.3806 11.3493ZM27.7616 15.8889C34.0286 15.8889 39.1108 20.9711 39.1108 27.2381C39.1108 33.5052 34.0286 38.5873 27.7616 38.5873C21.4945 38.5873 16.4124 33.5052 16.4124 27.2381C16.4124 20.9711 21.4945 15.8889 27.7616 15.8889ZM27.7616 20.4286C25.9556 20.4286 24.2236 21.146 22.9465 22.4231C21.6695 23.7001 20.9521 25.4321 20.9521 27.2381C20.9521 29.0441 21.6695 30.7762 22.9465 32.0532C24.2236 33.3302 25.9556 34.0477 27.7616 34.0477C29.5676 34.0477 31.2996 33.3302 32.5766 32.0532C33.8537 30.7762 34.5711 29.0441 34.5711 27.2381C34.5711 25.4321 33.8537 23.7001 32.5766 22.4231C31.2996 21.146 29.5676 20.4286 27.7616 20.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.6f13f4f726e288b88fdf0066757addc0.svg";
export { ForwardRef as ReactComponent };